import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import DatetimePicker from 'vuetify-datetime-picker';

import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.use(DatetimePicker);
new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');